<template>
  <tr>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_work_extra_types',
          })
        "
        class="buttons"
      >
        <WorkExtraTypeModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          type="workExtraType"
          :text="
            localStorage.translations.pages['setting-work_extra_type']['dialog-delete'][
              'udalit-vid-dopolnitelnoy-raboty'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkExtraTypeModal from 'components/setting/workExtraType/WorkExtraTypeModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkExtraTypeTableItem',
  components: { WorkExtraTypeModal, DeleteModal },
  props: ['item'],
}
</script>
